export const getApiConstants = () => {
  const config = useRuntimeConfig()
  const API_URL = (config.public.golangApiUrl || '') + '/api/'

  return {
    BRAND: `${API_URL}brand/`,
    CITY: `${API_URL}city/`,
    LOGGING: `${API_URL}logging/`,
    LOCATION: `${API_URL}location/`,
    PRICECHANGE: `${API_URL}pricechange/`,
    PRODUCT: `${API_URL}product/`,
    PRODUCTFACET: `${API_URL}productfacet/`,
    PRODUCTPRICE: `${API_URL}productprice/`,
    PRODUCTPRICEHISTORY: `${API_URL}productpricehistory/`,
    REGION: `${API_URL}region/`,
    RETAILER: `${API_URL}retailer/`,
    SUMMARY: `${API_URL}summary/`,
    SYSTEM: `${API_URL}system/`,
    USERFEEDBACK: `${API_URL}userfeedback/`,
  }
}

export const ICONCONSTANTS = {
  ACTIONBUTTON: 'i-lucide-ellipsis-vertical',
  APPEAREANCE: 'i-lucide-sun-moon',
  APPEAREANCEDARK: 'i-lucide-moon',
  APPEAREANCELIGHT: 'i-lucide-sun',
  BILLING: 'i-lucide-credit-card',
  BRAND: 'i-lucide-copyright',
  CARDVIEW: 'i-lucide-layout-template',
  CHARTVIEW: 'i-heroicons-chart-bar',
  CHECK: 'i-lucide-shield-check',
  CITY: 'i-lucide-map-pin',
  CLOSE: 'i-heroicons-x-circle',
  DAY: 'i-lucide-calendar-days',
  EMAIL: 'i-heroicons-envelope',
  ERROR: 'i-heroicons-exclamation-triangle',
  ERRORPASSWORDS: 'i-heroicons-exclamation-circle-20-solid',
  EXPORTTOCSV: 'i-lucide-file-spreadsheet',
  EXPORTTOPDF: 'i-lucide-printer',
  EYE: 'i-heroicons-eye',
  EYESLASH: 'i-heroicons-eye-slash',
  FEEDBACK: 'i-lucide-message-square',
  HOUSE: 'i-lucide-house',
  KEY: 'i-heroicons-key',
  INFO: 'i-lucide-info',
  LINKBUTTON: 'i-heroicons-arrow-right',
  LISTVIEW: 'i-lucide-rows-3',
  LOCATION: 'i-lucide-store',
  LOCKCLOSED: 'i-heroicons-lock-closed',
  LOGOUT: 'i-lucide-log-out',
  MESSAGE: 'i-lucide-text',
  PRICEHISTORY: 'i-lucide-receipt',
  PRODUCT: 'i-lucide-box',
  PRICECHANGES: 'i-lucide-badge-percent',
  REGION: 'i-heroicons-map',
  RETAILER: 'i-lucide-warehouse',
  SETTINGS: 'i-lucide-settings',
  SORTDOWN: 'i-lucide-arrow-down',
  SORTUP: 'i-lucide-arrow-up',
  SORTUPDOWN: 'i-lucide-arrow-up-down',
  SUBJECT: 'i-lucide-heading',
  SUCCESS: 'i-heroicons-check-circle',
  SUMMARYVIEW: 'i-lucide-layout-dashboard',
  VIEWEYE: 'i-lucide-view',
  USER: 'i-heroicons-user',
  USER2: 'i-lucide:user'
}

export const PAGINGCONSTANTS = {
  DEFAULT_ITEMS_PER_PAGE: 20
}
